const cookieName = 'params_value';
const ttlDays = 90;

export function getTrackingData() {
    if (!import.meta.client) return;

    try {
        const cookie = useCookie(cookieName).value;
        if (cookie) return cookie;

        const ls = localStorage.getItem(cookieName);
        if (ls) return JSON.parse(ls);
    } 
    catch (err) {
        console.error(err);
    }
}

export function setTrackingData(data: object) {
    if (!import.meta.client) return;

    try {
        const payload = JSON.stringify(data);
        const cookie = useCookie(cookieName, {
            maxAge: 24 * 60 * 60 * ttlDays,
            sameSite: 'lax',
            path: '/'
        });
        cookie.value = payload;
        localStorage.setItem(cookieName, payload);
    } 
    catch (err) {
        console.error(err);
    }
}